<template>
  <div>
  </div>
</template>

<script>

import Rockestate3D from './renderer3d'

export default {
  props: {
      buildingId: String,
      solarPotential: String,
  },
  components: {
  },
  data:function() {
    return{
    }
  },
  mounted(){
    Rockestate3D.api_url = process.env.VUE_APP_API_URL;
    Rockestate3D.attach(this.$el);
    if (this.solarPotential != 'true') {
      this.solarPotential = 'false'
    }
    this.$axios
          .get(
              process.env.VUE_APP_API_URL + '/map/scene',
            { params: {building_id: this.buildingId, solar_potential: this.solarPotential, radius: 40} })
          .then((response) => {
              Rockestate3D.build_neighbourhood(response.data)
          });
  },
  computed: {
  },
  methods:{
  },
}
</script>

<style lang="scss" scoped>
div {
    height: 100%;
    width: 100%;
}
</style>
